import React from 'react';

const JSDisplayWidgetCollapsibleReplicaBtn = (props) => {
  const collapsed = props.collapsed;

  let cl = "js-widget-collapsible-h__replica-btn";
  let jsxBtn = null;
  if (collapsed === true) {
    cl += ' js-widget-collapsible-h__replica-btn--collapsed';
    jsxBtn = (
      <i className="fa fa-plus-square-o" aria-hidden="true"></i>
    );
  } else {
    // default is not collapsed beacuse purpose of this button is to easily collapse something with very high height if needed
    cl += ' js-widget-collapsible-h__replica-btn--not-collapsed';
    jsxBtn = (
      <i className="fa fa-minus-square-o" aria-hidden="true"></i>
    );
  }

  return (
    <div className={cl} onClick={props.handleClick}>{jsxBtn}</div>
  );
};

export default JSDisplayWidgetCollapsibleReplicaBtn;